import {Component, EventEmitter, Input, Output} from '@angular/core';
import {insertModeDetailsMap, MovementManagerInsertModeEnum} from "./movement-manager-insert-mode.enum";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import { CtManagerService } from 'projects/ct-manager/src/app/_core/lib/ct-manager.service';

@Component({
  selector: 'app-movement-manager-insert-mode',
  templateUrl: './movement-manager-insert-mode.component.html',
  styleUrls: ['./movement-manager-insert-mode.component.scss']
})
export class MovementManagerInsertModeComponent {

  @Output() onInsert: EventEmitter<MovementManagerInsertModeEnum | null> = new EventEmitter<MovementManagerInsertModeEnum | null>();
  @Input() enableWerehouse = false;

  form: FormGroup;
  control = new FormControl(null)

  // Flag per controllare la visibilità di FreeInput
  private showFreeInput = true;

  constructor(private formBuilder: FormBuilder, private managerService: CtManagerService) {

    this.form = this.formBuilder
      .group({
        insertMode: this.control
      })

    this.form.valueChanges
      .subscribe(() => {
        this.onInsert.emit(this.form.value.insertMode)
      })

    // Gestione override per Offer
    this.managerService.getComponentOverride("workOrder", "insertOffert", this.insertModeDetailsMap[MovementManagerInsertModeEnum.Offer]).then((component) => {
      return;
    });

    // Gestione override per FreeInput
    this.managerService.getComponentOverride("workOrder", "insertFreeInput", { visible: true }).then((config) => {
      if (config && typeof config.visible === 'boolean') {
        this.showFreeInput = config.visible;
      }

    });

  }

  getEnumKeys() {

    if(this.enableWerehouse){
      return Object
        .keys(this.insertModes)
        .filter((key: any) => !isNaN(Number(this.insertModes[key])))
        .filter((key: any) => {
          const enumValue = this.insertModes[key as keyof typeof this.insertModes];
          // Filtra FreeInput se non deve essere visibile
          if (enumValue === MovementManagerInsertModeEnum.FreeInput) {
            return this.showFreeInput;
          }
          return true;
        });
    }

    // Modalità standard: filtra FreeInput se necessario
    const standardReturn = [];

    if (this.showFreeInput) {
      standardReturn.push(this.insertModes[MovementManagerInsertModeEnum.FreeInput]);
    }

    standardReturn.push(this.insertModes[MovementManagerInsertModeEnum.Offer]);

    return standardReturn;

  }


  // Helper per convertire la chiave dell'enum nel valore numerico
  getEnumValue(key: any): MovementManagerInsertModeEnum {
    return this.insertModes[key as keyof typeof this.insertModes] as MovementManagerInsertModeEnum;
  }
  getVisibleButtonsCount(): number {
  return this.getEnumKeys()
    .filter(mode => {
      const enumValue = this.getEnumValue(mode);
      return this.insertModeDetailsMap[enumValue]?.visible === true;
    })
    .length;
}
getButtonWidth(): string {
  const count = this.getVisibleButtonsCount();
  return count === 1 ? '50%' : '100%';
}
  protected readonly insertModeDetailsMap = insertModeDetailsMap;
  protected readonly insertModes = MovementManagerInsertModeEnum;

}
